/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import BaseCom from "../BaseCom";
import FormInput from "../FormInput";
import Card from "../Card";
import Address from "../Address";
import React from "react";

export default class AccountQuickEdit extends BaseCom {

    change = () => {
        this.forceUpdate();
        this.props.onChange?.();
    }

    render() {

        return (
            <div>
                <div className="row">
                    <div className="col-md">
                        <Card title="Basic Information">
                            <FormInput model={this.props.item} name="name" label="Name" type="text" required={true} />
                        </Card>
                    </div>
                </div>


                <div className="row">
                    <div className="col-md-6">
                        <Card title="Contact Information">
                            <div className="row">
                                <div className="col-md">
                                    <FormInput model={this.props.item} name="phone" label="Phone" type="text" />
                                </div>
                                <div className="col-md">
                                    <FormInput model={this.props.item} name="fax" label="Fax" type="text" />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-7">
                                    <FormInput model={this.props.item} name="email" label="Email" type="email" />
                                </div>
                                <div className="col-md-5">
                                    <FormInput model={this.props.item} name="contactName" label="Contact Name" type="text" />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md">
                                    <FormInput model={this.props.item} name="phone" label="Phone" type="text" />
                                </div>
                                <div className="col-md">
                                    <FormInput model={this.props.item} name="fedexAccountNumber" label="FedEx Account Number" type="text" />
                                </div>
                            </div>
                        </Card>
                    </div>
                    <div className="col-md-6">
                        <Address
                            title="Shipping Address"
                            item={this.props.item.shippingAddress}
                            required={true}
                            onChange={this.change}
                        />
                    </div>
                </div>
            </div>
        );
    }
}
